import type { Session } from '../client';
import { DefaultCollapseGroupId, SessionOperate, type SessionCategoryPrefix } from '../sdk';

export function isSessionCategory(chat_id: string | undefined, category: SessionCategoryPrefix) {
  return chat_id?.startsWith(category) ?? false;
}

export interface SessionUnreadCount {
  unread_count: number;
  muted_unread_count: number;
}

export function getSessionUnreadCount(session: Session): SessionUnreadCount {
  let unread_count = 0;
  let muted_unread_count = 0;

  const isMarkedUnread = session.operateAccess?.[SessionOperate.MARKED_UNREAD];
  const isMuted = session.operateAccess?.[SessionOperate.MUTED];

  const isCollapsedChat = session.chat_id === DefaultCollapseGroupId;
  if (isCollapsedChat) {
    return {
      unread_count: 0,
      muted_unread_count: session.unread_count,
    };
  }

  if (isMarkedUnread) {
    if (isMuted) {
      muted_unread_count = 1;
    } else {
      unread_count = 1;
    }
  } else if (isMuted) {
    unread_count = 0;
    muted_unread_count = session.unread_count;
  } else {
    unread_count = session.unread_count;
    muted_unread_count = 0;
  }

  return {
    unread_count,
    muted_unread_count,
  };
}

export function getSessionsUnreadCount(sessions: Session[]): SessionUnreadCount {
  return sessions.reduce(
    (acc, session) => {
      const { unread_count, muted_unread_count } = getSessionUnreadCount(session);
      const isCollapsed = !!session.collapse_group_id;
      if (isCollapsed) {
        const hasMsg = muted_unread_count > 0;
        return {
          unread_count: acc.unread_count + unread_count,
          muted_unread_count: acc.muted_unread_count + (hasMsg ? 1 : 0),
        };
      }
      return {
        unread_count: acc.unread_count + unread_count,
        muted_unread_count: acc.muted_unread_count + muted_unread_count,
      };
    },
    { unread_count: 0, muted_unread_count: 0 }
  );
}
